import type {CarrierOption} from '@/types/CarrierOption';

export const isEnabled = (carrierOption: CarrierOption): boolean => {
  return carrierOption.enabled === 1;
};
